import { render } from "./Select.vue?vue&type=template&id=84751c7a&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&id=84751c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84751c7a"]])

export default __exports__